import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';

import './StepHeader.scss'

export default withTranslation()(function StepHeader({
    t, 
    i18n, 
    step, 
    title, 
    branding, 
    importantNote, 
    mandatory,
    pointsToNote3,
    pointsToNote4
}) {
    return (
        <>
            {
                pointsToNote3 &&
                <Box 
                    border={1}
                    borderColor="primary.grey" 
                    p={5}
                    mb={5}
                >
                    <Typography variant="h6">
                        {t('common.PointsToNote')}
                    </Typography>
                    <Typography variant="subtitle1">
                        {t('common.importantLink4')}
                    </Typography>
                    <a 
                        href={`https://www.td.gov.hk/${i18n.language}/public_forms/td_forms/permit/`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {`https://www.td.gov.hk/${i18n.language}/public_forms/td_forms/permit/`}
                    </a>
                    <br /><br />
                    <Typography variant="subtitle1">
                        {t('common.importantDesc5')}
                    </Typography>
                </Box>
            }
            {
                pointsToNote4 &&
                <Box 
                    border={1}
                    borderColor="primary.grey" 
                    p={5}
                    mb={5}
                >
                    <Typography variant="h6">
                        {t('common.PointsToNote')}
                    </Typography>
                    <Typography variant="subtitle1">
                        {t('common.importantLink3')}
                    </Typography>
                    <a 
                        href={`https://www.td.gov.hk/${i18n.language}/public_forms/td_forms/permit/`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {`https://www.td.gov.hk/${i18n.language}/public_forms/td_forms/permit/`}
                    </a>
                    <br/><br/>
                    <Typography variant="subtitle1">
                        {t('common.importantDesc6')}
                    </Typography>
                </Box>

            }
            <Box className="stepHeader">
                <Typography variant="h6" className="stepIndicator">
                    {t(step)}
                </Typography>
                <Typography variant="h6" className="stepTitle">
                    {t(title)}
                </Typography>
            </Box>
            {
                mandatory &&
                <Typography variant="body2" className="manda">
                    {t('common.mandatory1')} <Box component="span" className="danger">*</Box> {t('common.mandatory2')}
                </Typography>
            }
        </>
    )
})
